module.exports = __webpack_public_path__ + "static/media/coummuntiy_0.a5ebde4b.svg";